module.exports = new __parcel__URL__("Full-Stack.985585a3.jpg").toString();